import type { Detection, ProductType } from "./types";

/** Minimal template shape the selector needs (subset of MappingProfile). */
export type TemplateSummary = {
  id: string;
  name: string;
  productType: ProductType;
  isDefault: boolean;
};

/**
 * Pick which template to auto-load given a customer's templates and a
 * product-type detection. Preference: exact productType match, isDefault first,
 * else the first match. Returns null when nothing matches (operator picks
 * manually). Pure/total — never throws. Confidence is intentionally ignored
 * here; the UI decides whether to flag a low-confidence auto-load.
 */
export function pickTemplateForDetection(
  templates: TemplateSummary[],
  detection: Detection,
): TemplateSummary | null {
  const matches = templates.filter((t) => t.productType === detection.type);
  if (matches.length === 0) return null;
  return matches.find((t) => t.isDefault) ?? matches[0];
}
